<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de categorías</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Nombre">
                    <b-form-input v-model="filterTypesSubCategoriesSga.name" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Estado">
                    <el-select v-model="filterTypesSubCategoriesSga.is_active" clearable filterable size="medium"
                        placeholder="Buscar por estado">
                        <el-option v-for="item in statesSga" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchTypesSubCategoriesSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <el-tooltip effect="light" placement="top" popper-class="py-1 px-2" content="Sincronizar idiomas">
                        <b-button variant="warning" class="ml-1 mr-1" @click="asyncLanguagesTypesSubCategoriesSga">
                            <i class="fa fa-language" aria-hidden="true"></i>
                        </b-button>
                    </el-tooltip>
                    <b-button variant="primary" @click="createTypeSubCategorySga">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nueva categoría'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_typesubcategory" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nueva' }} categoría
                </template>
                <formTypesSubCategories />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="typesSubCategoriesSga.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                                v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                <el-tooltip content="Editar" placement="top" effect="light">
                                    <el-button type="text" class="text-primary" @click="editTypeSubCategory(data.item)">
                                        <i class="fa fa-edit fa-lg"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterTypesSubCategoriesSga.page"
                            :total="filterTypesSubCategoriesSga.total" :current-page="filterTypesSubCategoriesSga.page"
                            :page-size="filterTypesSubCategoriesSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import formTypesSubCategories from './FormTypesSubCategories.vue';
export default {
    name: 'TypesSubCategories',
    components: {
        formTypesSubCategories,
    },
    data() {
        return {
            fields: [
                {
                    key: "name",
                    label: "Nombre",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ],
        };
    },

    computed: {
        ...mapState('sgaTypesSubCategories', ['typesSubCategoriesSga', 'action', 'filterTypesSubCategoriesSga']),
        ...mapState('sgaVersions', ['statesSga']),
    },

    methods: {
        ...mapActions('sgaTypesSubCategories', ['getTypesSubCategoriesSga', 'changeStatusTypeSubCategorySga', 'showTypeSubCategorySga', 'asyncLanguagesTypesSubCategoriesSga']),
        ...mapMutations('sgaTypesSubCategories', ['setActionTypeSubCategorySga', 'setDefaultFilterTypesSubCategories', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination']),

        createTypeSubCategorySga() {
            this.setActionTypeSubCategorySga('create');
            this.$bvModal.show('modal_create_typesubcategory');
        },

        async clearFilter() {
            this.setDefaultFilterTypesSubCategories();
            await this.getTypesSubCategoriesSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getTypesSubCategoriesSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getTypesSubCategoriesSga();
        },

        async changeStatus(id) {
            await this.changeStatusTypeSubCategorySga(id);
            await this.getTypesSubCategoriesSga();
        },

        editTypeSubCategory(typeSubCategory) {
            this.showTypeSubCategorySga(typeSubCategory.id);
            this.setActionTypeSubCategorySga('edit');
            this.$bvModal.show('modal_create_typesubcategory');
        },

        async searchTypesSubCategoriesSga() {
            await this.getTypesSubCategoriesSga(true);
        },
    },
};
</script>
